var _rect, _rect2, _g, _path, _circle, _rect3, _rect4, _circle2, _rect5, _rect6, _circle3, _rect7, _rect8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgIntroduction2Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 255,
    viewBox: "0 0 343 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1604_10870)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 255,
    rx: 16,
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1604_10870",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 38,
    width: 245,
    height: 223
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38,
    width: 245,
    height: 222.103,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1604_10870)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1604_10870)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.3457,
    y: 38,
    width: 187.483,
    height: 296.987,
    rx: 34,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3457,
    y: 42,
    width: 179.483,
    height: 288.987,
    rx: 30,
    stroke: "#2B2B2B",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135.348,
    y: 38,
    width: 71.4778,
    height: 19.9556,
    rx: 9.97782,
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1604_10870)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.885,
    y: 47.9766,
    width: 16.4047,
    height: 3.52158,
    rx: 1.76079,
    fill: "#666666"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.12 89.7666V102.18H158.448V89.7666H161.12ZM146.666 97.8008C149.625 96.8452 150.71 94.5166 150.71 92.3271V90.6943H153.494V92.3271C153.475 94.4702 154.505 96.6318 157.39 97.5225L156.036 99.6191C154.134 99.0068 152.854 97.8193 152.111 96.2886C151.351 97.9399 150.033 99.2573 148.057 99.8975L146.666 97.8008ZM149.579 106.503V100.955H152.288V104.369H161.546V106.503H149.579ZM172.958 91.4365V93.5332H169.664C169.738 95.1196 170.861 96.7803 173.588 97.4668L172.345 99.5078C170.443 99.0439 169.145 98.042 168.365 96.7524C167.623 98.2368 166.306 99.4058 164.311 99.9531L163.068 97.875C165.795 97.1235 166.918 95.3052 166.983 93.5332H163.699V91.4365H166.983V89.6924H169.673V91.4365H172.958ZM165.888 103.497C165.888 101.428 168.152 100.278 171.77 100.269C175.435 100.278 177.698 101.428 177.708 103.497C177.698 105.584 175.435 106.8 171.77 106.781C168.152 106.8 165.888 105.584 165.888 103.497ZM168.542 103.497C168.542 104.341 169.646 104.768 171.77 104.777C173.978 104.768 175.036 104.341 175.054 103.497C175.036 102.671 173.978 102.291 171.77 102.31C169.646 102.291 168.542 102.671 168.542 103.497ZM172.457 96.3535V94.2197H174.999V89.748H177.652V100.046H174.999V96.3535H172.457ZM186.243 93.3662C186.243 96.6133 187.31 99.7305 190.25 100.974L188.636 103.107C186.781 102.226 185.584 100.649 184.888 98.6729C184.174 100.779 182.931 102.486 181.01 103.423L179.34 101.233C182.393 99.8882 183.515 96.5947 183.534 93.3662V91.0098H186.243V93.3662ZM188.339 97.1143V94.9619H191.457V89.748H194.091V106.818H191.457V97.1143H188.339Z",
    fill: "#2B2B2B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.243,
    cy: 142.168,
    r: 15,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 133,
    width: 89,
    height: 7,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 143.243,
    y: 146.168,
    width: 72,
    height: 7,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.243,
    cy: 181.168,
    r: 15,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 172,
    width: 89,
    height: 7,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 143.243,
    y: 185.168,
    width: 72,
    height: 7,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.243,
    cy: 220.168,
    r: 15,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 211,
    width: 89,
    height: 7,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 143.243,
    y: 224.168,
    width: 72,
    height: 7,
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1604_10870",
    x: 73.3457,
    y: 38,
    width: 195.483,
    height: 304.986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1604_10870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1604_10870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1604_10870",
    x: 162.885,
    y: 47.9766,
    width: 17.4048,
    height: 4.52148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1604_10870"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1604_10870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 255,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIntroduction2Mobile);
export default __webpack_public_path__ + "static/media/ImgIntroduction2Mobile.e696f65ea52a0a3fbe9bc46f6026cd6c.svg";
export { ForwardRef as ReactComponent };